import React from 'react';
import { Flex } from '@chakra-ui/react';

import { useBannerSize } from '../../../../common/hooks/use-banner-size';
import { BannerDivider, ChargeSpeedCell, CumulativePowerCell, TariffCell } from './banner-cells';

type ChargingBannerContentProps = {
  hasTariff: boolean;
  rate?: string;
  kwhConsumed: number;
  powerFormatted: string;
};

export function ChargingBannerContent({ hasTariff, rate, kwhConsumed, powerFormatted }: ChargingBannerContentProps) {
  const { h } = useBannerSize();
  return (
    <Flex align="center" w="100%" h={h}>
      <CumulativePowerCell kwhConsumed={kwhConsumed} />
      <BannerDivider />
      <ChargeSpeedCell powerFormatted={powerFormatted} />
      <BannerDivider />
      <TariffCell hasTariff={hasTariff} rate={rate} />
    </Flex>
  );
}
